import { Toast } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { APP_TYPE, formToObject } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import LoginV2Single from "../loginV2Single";
import LoginWithOtp from "./loginWithOtp";
import LoginwithDob from "./loginwithDob";
import Footer from "../footer";

const Login = (props) => {
  const context = useContext(PsContext);

  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  const [validated, setValidated] = useState(false);

  const [serverResponse, setServerResponse] = useState("");

  useEffect(() => {
    console.log(context.settingValue("staff_login_type", ""));
    //context.loadSettings();
    if (context.mobilePass && context.mobilePass.length < 1)
      context.setStorage("mob_attendance_date", "");
  }, []);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    if (APP_TYPE != "SAAS") {
      checkLogin(form);
      return;
    }
    let fx = formToObject(form);
    const f = new FormData();

    f.append("username", fx.mobile_no + "@" + context.dbPostfix);
    axios.post(ServiceUrl.LOGIN_V2.CHECK, f).then((res) => {
      if (res["data"].status == "1") {
        axios.defaults.headers.common["Api-Token"] = `${res["data"].api}`;
        //setRedirect(res["data"].data);
        checkLogin(form);
      } else {
        Toast.show({
          content: res["data"].message || "Error",
          position: "top",
        });
        setLoader(false);
      }
    });
  };

  const checkLogin = (form) => {
    setLoader(true);
    axios
      .post(ServiceUrl.MOB.CHECK_USERNAME, new FormData(form))
      .then((res) => {
        if (res["data"].status == "1") {
          context.updateMobileUserId(res["data"].data);
          setServerResponse(res["data"].data);
        } else {
          //toast.error(res["data"].message || "Error");
          Toast.show({
            content: res["data"].message || "Error",
            position: "top",
          });
        }
        setLoader(false);
      });
  };

  const getLoginForm = () => {
    if (
      context.settingValue("staff_login_type", "") == "with_pass" &&
      APP_TYPE == "SAAS"
    ) {
      return <LoginwithDob />;
    } else if (context.settingValue("staff_login_type", "") == "with_pass") {
      return <LoginV2Single />;
    } else return <LoginWithOtp />;
  };

  if (context.logged == "yes") {
    //history.push("/app");
    return <Navigate to="/staff/app" replace={true} />;
    return null;
  } else {
    return (
      <>
        <Header
          title="Staff Login"
          backAction={[]}
          rightActions={[]}
          onBack={(e) => navigate("/")}
        ></Header>

        {getLoginForm()}

        <Footer />
      </>
    );
  }
};
export default Login;
